angular.module('am4').directive('noMatch', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ngModelCtrl) {
            ngModelCtrl.$validators.noMatch = function(modelValue) {
                return modelValue !== scope.$eval(attrs.noMatch);
            };

            scope.$watch(attrs.noMatch, function() {
                ngModelCtrl.$validate();
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/noMatch.js